import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { useForm } from '../../../../contexts/form-context';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { FIELD_PROPS_MAPPERS } from '../../../../mappers/public-props-map';
export const ReadOnlyField = _ref => {
  let {
    field,
    FieldLayout
  } = _ref;
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const {
    requiredIndicator,
    requiredIndicatorPlacement
  } = form.requiredIndicatorProperties || {};
  const propsMapper = FIELD_PROPS_MAPPERS[field.fieldType];
  const FieldComponent = componentsById[field.fieldType];
  if (!FieldComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldPropsContext.Provider, {
    value: {
      ...propsMapper({
        ...field.properties,
        id: field.id,
        externalData,
        fieldType: field.fieldType,
        requiredIndicatorType: requiredIndicator,
        requiredIndicatorPlacement
      })
    }
  }, /*#__PURE__*/React.createElement(FieldComponent, _extends({}, field.properties, {
    id: field.id,
    externalData: externalData,
    fieldType: field.fieldType,
    FieldLayout: FieldLayout,
    requiredIndicatorType: requiredIndicator,
    requiredIndicatorPlacement: requiredIndicatorPlacement
  })));
};
//# sourceMappingURL=read-only-field.js.map